'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'film-canister';
var width = 576;
var height = 512;
var aliases = ["film-cannister"];
var unicode = 'f8b7';
var svgPathData = 'M112 48l0-24c0-13.3 10.7-24 24-24L248 0c13.3 0 24 10.7 24 24l0 24 80 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-16 0 0 416 16 0c4.4 0 8 3.6 8 8s-3.6 8-8 8L16 496c-4.4 0-8-3.6-8-8s3.6-8 8-8l16 0 0-416-16 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l96 0zM256 24c0-4.4-3.6-8-8-8L136 16c-4.4 0-8 3.6-8 8l0 24 128 0 0-24zM48 64l0 416 272 0 0-416-272 0zm56 64c4.4 0 8 3.6 8 8l0 272c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-272c0-4.4 3.6-8 8-8zM456 432l-72 0 0-16 72 0c13.3 0 24-10.7 24-24l0-40c0-22.1 17.9-40 40-40l16 0c13.3 0 24-10.7 24-24l0-136c0-13.3-10.7-24-24-24l-152 0 0-16 152 0c22.1 0 40 17.9 40 40l0 136c0 22.1-17.9 40-40 40l-16 0c-13.3 0-24 10.7-24 24l0 40c0 22.1-17.9 40-40 40z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFilmCanister = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;